import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from '@mui/styles/withStyles';
import { getTagTypes } from '@pingum/app-state-management/tagType/actions';
import Tag from '../Tag';
import {
  getColorForItem,
  getIconForItem,
} from '../../utils/iconHelper';
import { getChipForTags } from '../../utils/tagsHelper';
import styles from './styles';

export class TagListComponent extends React.Component {
  constructor(props) {
    super(props);

    if (props.tagTypes.length === 0 && !props.isFetching) {
      props.getTagTypes();
    }
  }

  render() {
    const {
      tags,
      maxTags,
      classes,
      disableGutters,
    } = this.props;

    if (tags.length === 0) {
      return '-';
    }

    const filteredTags = tags
      .sort((a, b) => (a.tagType || {}).id - (b.tagType || {}).id)
      .slice(0, maxTags || tags.length);

    return (
      <span>
        {
          filteredTags
            .map((tag) => {
              const { tagType = {} } = tag;

              if (!tag.name) {
                return <span key={-1} />;
              }

              const questriTag = getChipForTags([tag], this.props.barnHorsesMap, this.props.locationsMap, { disableGutters });
              if (questriTag === 'Unknown') {
                return (
                  <span
                    key={`tag-${tag.id}`}
                  >
                    <Tag
                      tag={tag}
                      icon={this.props.removeIcon
                        ? null
                        : getIconForItem(this.props.tagTypes, tagType.id)}
                      color={getColorForItem(this.props.tagTypes, tagType.id)}
                      size={this.props.size}
                      disableGutters={disableGutters}
                    />
                  </span>
                );
              }
              return questriTag;
            })
        }
        {
          filteredTags.length < tags.length
            && (
              <span className={classes.more} key={`spacer-tag-list-${tags.length - filteredTags.length}`}>
                +{tags.length - filteredTags.length}&nbsp;more
              </span>
            )
        }
      </span>
    );
  }
}

TagListComponent.propTypes = {
  tags: PropTypes.array,
  tagTypes: PropTypes.array,
  getTagTypes: PropTypes.func,
  isFetching: PropTypes.bool,
  maxTags: PropTypes.number,
  classes: PropTypes.object,
  size: PropTypes.string,
  removeIcon: PropTypes.bool,
  barnHorsesMap: PropTypes.object,
  locationsMap: PropTypes.object,
  disableGutters: PropTypes.bool,
};

TagListComponent.defaultProps = {
  tags: [],
  tagTypes: [],
  getTagTypes: () => {},
  isFetching: false,
  maxTags: null,
  classes: {},
  size: 'small',
  removeIcon: false,
  barnHorsesMap: {},
  locationsMap: {},
  disableGutters: false,
};

export const mapStateToProps = (state) => ({
  tagTypes: state.tagType.tagTypes,
  isFetching: state.tagType.isFetchingTagTypes,
  barnHorsesMap: state.barn.barnHorsesMap,
  locationsMap: state.location.locationsMap,
});

export const mapDispatchToProps = (dispatch) => ({ getTagTypes: () => dispatch(getTagTypes(false, true)) });

export default withStyles(styles)(connect(
  mapStateToProps,
  mapDispatchToProps,
)(TagListComponent));
